import React from 'react';
import './HeaderOptions.css'
import { useHistory } from 'react-router-dom';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';

function HeaderOptions() {
    const history = useHistory();

    return (
        <div className="headerOptions">
            <div className="headerOptions__top">
                <div onClick={(e) => history.push('/')} className="headerOptions__option"><h3>Home</h3></div>
                <div onClick={(e) => history.push('/about')} className="headerOptions__option"><h3>About us</h3></div>
                <div onClick={(e) => history.push('/ministries')} className="headerOptions__option"><h3>Ministries</h3></div>
                {/* <div onClick={(e) => history.push('/work')} className="headerOptions__option"><h3>work with us</h3></div> */}
                <div onClick={(e) => history.push('/sermons')} className="headerOptions__option"><h3>Sermons | Services</h3></div>
                {/* <div onClick={(e) => history.push('/contacts')} className="headerOptions__option"><h3>Contact</h3></div> */}
            </div>

            <div className="search">
                <button>
                    <AddShoppingCartIcon className="donate-Icon"/>
                    Donate
                </button>
            </div>

        </div>
    )
}

export default HeaderOptions
